import { DarkTheme, type Theme } from '@react-navigation/native';
import { ticketColors } from '../../shared/theme/ticketColors';

/** Tema ticket compartido para evitar flash blanco en transiciones del stack. */
export const navigationTheme: Theme = {
  ...DarkTheme,
  dark: true,
  colors: {
    ...DarkTheme.colors,
    primary: ticketColors.gold,
    background: ticketColors.bg,
    card: ticketColors.bg,
    text: ticketColors.ink,
    border: ticketColors.rule,
    notification: ticketColors.bad,
  },
};

export const shellSceneContentStyle = {
  flex: 1,
  minHeight: 0,
  backgroundColor: ticketColors.bg,
} as const;
